import { TEST_USER } from "../test-user";

/**
 * `/locations/:id`: the record the location-edit view renders (`id` is filled
 * in per-request from the route param — see `handlers/tech-ui.ts`). `name` is
 * the distinctive seeded value the smoke spec asserts on (it drives the
 * breadcrumb and proves the view rendered from this response rather than
 * hanging on the spinner). `slaId` is non-null so the view doesn't also fire
 * a default-SLA lookup, and no `iso`/`powerGridZone` is set so it doesn't
 * also fire a power-grid-zone lookup — both out of scope for this view.
 */
const SEEDED_LOCATION = {
  name: "E2E Seeded Location",
  operator: { id: TEST_USER.operatorId },
  company: { id: TEST_USER.companyId },
  isPublic: 1,
  slaId: 1,
  lat: 55.6761,
  lon: 12.5683,
  facilities: [],
  parkingPlaces: [],
  associations: [],
};

export { SEEDED_LOCATION };
